<template>
    <div class="padding_side">
        <competition-list-component :competition-type="'competitionUserMy'"
                                    :member-key="UserInfo.mb_no"></competition-list-component>
    </div>
</template>

<script>
import {mapState} from "vuex";
import AuthMixins from "@/mixins/AuthMixins";
import {logout} from "@/mixins/Auth";
import CompetitionListComponent from "@/components/competition/CompetitionListComponent";

export default {
    name: "MyProfileCompetition",
    mixins: [AuthMixins],
    components: {
        CompetitionListComponent,
    },
    inject: [],
    provide() {
        return {}
    },
    props: {},
    data() {
        return {
            tab: 'galleryMy',
        }
    },
    beforeRouterEnter() {
    },
    created() {
        // -0--
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {
        ...mapState({
            UserInfo: state => state.userInfo.UserInfo,
        })
    },
    methods: {
        movePage(url) {
            this.$router.push(url);
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
